import Vue from 'vue';
import EditMissionModel from '@/Classes/800/EditMissionCall.js';
// import MissionTransformMixin from "@/Mixins/Mission/mission.transform";
import PatientMixin from '@/Mixins/Doctor/PatientMixin';
import SharedHelper from '@/Helpers/Shared';

export default {
  inject: ['load', 'setUniqueId'],
  mixins: [
    // MissionTransformMixin,
    PatientMixin,
    SharedHelper,
  ],
  data() {
    return {
      currentMission115MainList: [],
      currentFollowUpCodesList: [],
      allMissionStartTriages: [],
      was1019: false,
      missionLocationInfo: {
        isWithinCity: false,
        missionPlaceType: null,
        isPlaceSecure: false,
        placeDescription: '',
      },
    };
  },
  methods: {
    getAllCallerHistoryForMissionFunction: function (callerId) {
      this.$store.dispatch('getAllCallerHistoryForMission', callerId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.callerHistoryInForm ?? [];
          for (const data of temp) {
            if (data.creationDate) {
              data.creationDate = Vue.moment(data.creationDate).format('HH:mm:ss jYYYY/jM/jD');
            }
          }
          this.callerHistoryInFormList = temp;
        } else {
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllCallerHistoryForMissionFunction(callerId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllCallerHistoryForMissionFunction(callerId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    transformMissionLocationInfo: function () {
      const fieldsArr = this.$store.state.recursiveFieldModule.fieldsArr?.sort(
        (a, b) => a.level - b.level,
      );

      this.missionLocationInfo.isWithinCity = Object?.values?.(fieldsArr?.[0] ?? {})?.some((item) =>
        item?.toString()?.includes('درون شهری'),
      );
      fieldsArr.shift();
      fieldsArr.forEach((item) => {
        delete item.level;

        this.missionLocationInfo = { ...this.missionLocationInfo, ...item };
      });
    },
    getListOfCurrentMissionFunction_OOLLDD: function () {
      if (!this.load.val && !this.$store.state.missionPhoneModule.mainList?.length) {
        this.load.val = true;
      }
      /*let element =
                this.$el.children[3]?.children[0]?.children[0]?.children[2]
                    ?.children[1]?.children[0]?.children[0]?.children[0]?.children[0]
                    ?.children[0]?.children[0]?.children[0];
            element.scrollLeft += element.scrollWidth;*/
      this.$store.dispatch('getMainListOfCurrentMision').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.mainList;
          this.currentMission115MainList = [];
          for (let i = 0; i < temp.length; i++) {
            let phone = '-';
            let user = '-';
            let iconType = '';
            let iconText = '';
            let toopak = '';
            let iconColor = '';
            let toopakId = '';
            let patiantPhoneNumbers = [];
            if (temp[i].id) {
              toopakId = temp[i].id.toString();
              toopakId = toopakId + temp[i].mission.id.toString();
            } else {
              toopakId = temp[i].mission.id.toString();
            }
            if (localStorage.getItem(toopakId)) {
              toopak = localStorage.getItem(toopakId);
            }
            if (temp[i].mission) {
              if (temp[i].mission.rank == 0) {
                iconColor = '#D1D1D1';
              } else if (temp[i].mission.rank == 1) {
                iconColor = '#3BCA79';
              } else if (temp[i].mission.rank == 2) {
                iconColor = '#F2BD27';
              } else if (temp[i].mission.rank == 3) {
                iconColor = '#F56060';
              }
              if (temp[i].mission.callerId) {
                phone = temp[i].mission.callerId;
                patiantPhoneNumbers.push(phone);
                if (temp[i].mission.otherPhoneNumber) {
                  phone += ' - ' + temp[i].mission.otherPhoneNumber;
                  let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                  for (let j = 0; j < tmpPhone.length; j++) {
                    patiantPhoneNumbers.push(tmpPhone[j]);
                  }
                }
              } else if (temp[i].mission.otherPhoneNumber) {
                phone = temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  if (tmpPhone[j]) {
                    patiantPhoneNumbers.push(tmpPhone[j]);
                  }
                }
              }
              if (temp[i].mission.creationUser) {
                user = temp[i].mission.creationUser.firstName
                  ? temp[i].mission.creationUser.firstName
                  : '-';
                user += ' ';
                user += temp[i].mission.creationUser.lastName
                  ? temp[i].mission.creationUser.lastName
                  : '-';
              }
              if (!temp[i].mission.dispatchDelivered && temp[i].mission.isDispatched == false) {
                iconType = 'before800';
                iconText = 'ارسال به 800';
              } else if (
                temp[i].mission.dispatchDelivered == true &&
                temp[i].mission.isDispatched == false
              ) {
                iconType = '800';
                iconText = 'رسیده به 800';
              } else if (
                temp[i].mission.dispatchDelivered == true &&
                temp[i].mission.isDispatched == true
              ) {
                iconType = 'send';
                iconText = 'اعزم شده';
              }
            }

            const stationTitle = temp[i]?.phone?.stationTitle;
            const ambulance = `${temp[i]?.phone?.code} ${stationTitle ? `(${stationTitle})` : ''}`;

            this.currentMission115MainList.push({
              ambulance: temp[i].phone ? ambulance : '-',
              address: temp[i].mission ? temp[i].mission.address : '-',
              cheifComlaint:
                temp[i].mission && temp[i].mission.diagnosis
                  ? temp[i].mission.diagnosis.title
                  : '-',
              codeStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              missionStatus: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              ambulanceStatus: temp[i].vehicleCurrentState ? temp[i].vehicleCurrentState : '-',
              hospital: temp[i].hospital ? temp[i].hospital.title : '-',
              phone: phone,
              user: user,
              iconType: iconType,
              iconText: iconText,
              id: temp[i].id ? temp[i].id : null,
              missionId: temp[i].mission ? temp[i].mission.id : null,
              toopakColor: toopak,
              phoneId: temp[i].phone ? temp[i].phone.id : null,
              hasAddressChanged: temp[i].mission ? temp[i].mission.hasAddressChanged : false,
              chiefComplaintText: temp[i]?.mission?.chiefComplaintText,
              chiefComplaintNote: temp[i]?.mission?.chiefComplaintNote,
              hasLackOfCode: temp[i].mission ? temp[i].mission.hasLackOfCode : false,
              codePhoneNumber: temp[i].phone ? temp[i].phone.phoneNumber : null,
              patiantPhoneNumbers: patiantPhoneNumbers,
              iconColor: iconColor,
              toopakId: toopakId,
              rank: temp[i].mission.rank,
              creationUserId: temp[i].mission?.creationUser?.id ?? null
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfCurrentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfCurrentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfCurrentMissionFunction: function () {
      if (!this.load.val && !this.$store.state.missionPhoneModule.mainList?.length) {
        this.load.val = true;
      }
      // RETURN the promise chain — getData() in the component awaits this;
      // without the return, the in-flight guard is blind
      return this.$store.dispatch('getMainListOfCurrentMision').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.mainList;

          // build into a LOCAL array — pushing into the reactive
          // this.currentMission115MainList inside the loop fires watchers per
          // item and flashes an empty table before refilling
          const rows = [];

          for (let i = 0; i < temp.length; i++) {
            let phone = '-';
            let user = '-';
            let iconType = '';
            let iconText = '';
            let toopak = '';
            let iconColor = '';
            let toopakId = '';
            let patiantPhoneNumbers = [];
            if (temp[i].id) {
              toopakId = temp[i].id.toString();
              toopakId = toopakId + temp[i].mission.id.toString();
            } else {
              toopakId = temp[i].mission.id.toString();
            }
            if (localStorage.getItem(toopakId)) {
              toopak = localStorage.getItem(toopakId);
            }
            if (temp[i].mission) {
              if (temp[i].mission.rank == 0) {
                iconColor = '#D1D1D1';
              } else if (temp[i].mission.rank == 1) {
                iconColor = '#3BCA79';
              } else if (temp[i].mission.rank == 2) {
                iconColor = '#F2BD27';
              } else if (temp[i].mission.rank == 3) {
                iconColor = '#F56060';
              }
              if (temp[i].mission.callerId) {
                phone = temp[i].mission.callerId;
                patiantPhoneNumbers.push(phone);
                if (temp[i].mission.otherPhoneNumber) {
                  phone += ' - ' + temp[i].mission.otherPhoneNumber;
                  let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                  for (let j = 0; j < tmpPhone.length; j++) {
                    patiantPhoneNumbers.push(tmpPhone[j]);
                  }
                }
              } else if (temp[i].mission.otherPhoneNumber) {
                phone = temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  if (tmpPhone[j]) {
                    patiantPhoneNumbers.push(tmpPhone[j]);
                  }
                }
              }
              if (temp[i].mission.creationUser) {
                user = temp[i].mission.creationUser.firstName
                  ? temp[i].mission.creationUser.firstName
                  : '-';
                user += ' ';
                user += temp[i].mission.creationUser.lastName
                  ? temp[i].mission.creationUser.lastName
                  : '-';
              }
              if (!temp[i].mission.dispatchDelivered && temp[i].mission.isDispatched == false) {
                iconType = 'before800';
                iconText = 'ارسال به 800';
              } else if (
                temp[i].mission.dispatchDelivered == true &&
                temp[i].mission.isDispatched == false
              ) {
                iconType = '800';
                iconText = 'رسیده به 800';
              } else if (
                temp[i].mission.dispatchDelivered == true &&
                temp[i].mission.isDispatched == true
              ) {
                iconType = 'send';
                iconText = 'اعزم شده';
              }
            }

            const stationTitle = temp[i]?.phone?.stationTitle;
            const ambulance = `${temp[i]?.phone?.code} ${stationTitle ? `(${stationTitle})` : ''}`;

            // each row frozen: Vue skips the deep reactivity walk over ~25 props
            // per row on every socket signal (rows are replaced wholesale)
            rows.push(Object.freeze({
              ambulance: temp[i].phone ? ambulance : '-',
              address: temp[i].mission ? temp[i].mission.address : '-',
              cheifComlaint:
                temp[i].mission && temp[i].mission.diagnosis
                  ? temp[i].mission.diagnosis.title
                  : '-',
              codeStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              missionStatus: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              ambulanceStatus: temp[i].vehicleCurrentState ? temp[i].vehicleCurrentState : '-',
              hospital: temp[i].hospital ? temp[i].hospital.title : '-',
              phone: phone,
              user: user,
              iconType: iconType,
              iconText: iconText,
              id: temp[i].id ? temp[i].id : null,
              missionId: temp[i].mission ? temp[i].mission.id : null,
              toopakColor: toopak,
              phoneId: temp[i].phone ? temp[i].phone.id : null,
              hasAddressChanged: temp[i].mission ? temp[i].mission.hasAddressChanged : false,
              chiefComplaintText: temp[i]?.mission?.chiefComplaintText,
              chiefComplaintNote: temp[i]?.mission?.chiefComplaintNote,
              hasLackOfCode: temp[i].mission ? temp[i].mission.hasLackOfCode : false,
              codePhoneNumber: temp[i].phone ? temp[i].phone.phoneNumber : null,
              patiantPhoneNumbers: patiantPhoneNumbers,
              iconColor: iconColor,
              toopakId: toopakId,
              rank: temp[i].mission.rank,
              creationUserId: temp[i].mission?.creationUser?.id ?? null
            }));
          }

          // ONE reactive assignment -> exactly one re-render, no mid-loop flicker
          this.currentMission115MainList = Object.freeze(rows);

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            // RETURN the retry chain so awaiting callers wait for it to finish
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getListOfCurrentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getListOfCurrentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    senMissionToPhoneFunction: function () {
      if (!this.selectedPhoneCode) {
        this.snackText = 'کد نمی تواند خالی باشد.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        missionId: Number(this.missionId),
        phoneId: Number(this.selectedPhoneCode),
        latitude: null,
        longitude: null,
      };
      if (this.selected800Position) {
        data.latitude = this.selected800Position.lat;
        data.longitude = this.selected800Position.lng;
      }
      this.$store.dispatch('addMissionPhone', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.$refs.confirm.showConfirmDialog = false;
          this.snackText = 'ماموریت با موفقیت ارسال شد';
          this.$refs.snackRef.snackModel = true;
          this.disabelConfirm = false;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.selectedReason = '';
          this.removeReason = '';
          this.mapSearchText = '';
          this.selectedPhoneCode = null;
          this.selected800Position = null;
          this.patiantPosition = null;
          clearInterval(this.mapMovingIconInterval);
          this.sendTOPhoneModal = false;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.stopSound2();
                this.senMissionToPhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.senMissionToPhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    sendMissionToOtherCodeFunction: function (is1051 = false) {
      if (!this.selectedPhoneCode) {
        this.snackText = 'کد نمی تواند خالی باشد.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      const data = {
        missionPhoneId: Number(this.missionPhoneId),
        phoneId: Number(this.selectedPhoneCode),
        latitude: null,
        longitude: null,
        is1051,
      };
      if (this.selected800Position) {
        data.latitude = this.selected800Position.lat;
        data.longitude = this.selected800Position.lng;
      }
      this.$store.dispatch('sendToOtherCode', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'ماموریت با موفقیت ارسال شد';
          this.$refs.confirm.showConfirmDialog = false;
          this.$refs.snackRef.snackModel = true;
          this.disabelConfirm = false;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.selectedReason = '';
          this.removeReason = '';
          this.mapSearchText = '';
          this.selectedPhoneCode = null;
          this.selected800Position = null;
          this.patiantPosition = null;
          clearInterval(this.mapMovingIconInterval);
          this.sendTOPhoneModal = false;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.sendMissionToOtherCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.sendMissionToOtherCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfDispatchBottomListFunction_OOLLDD: function (isManual = false) {
      this.$store.dispatch('getDispatchBotoomList').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.dispatchBottomList;
          this.bottomList = [];
          for (let i = 0; i < temp.length; i++) {
            let recivedToPhoneState = null;
            let recivedToPhoneStateColor = '';
            let user = '';
            let phone = '';
            let toopak = '';
            let toopakId = '';
            let icon = [];
            let patiantPhoneNumbers = [];
            let hospitalPhoneNumbers_split = [];
            this.listOf1024Missions = [];
            let rankIcon = '';
            let rankIconColor = '';
            // icon.push({
            //   type: 'voice',
            //   color: '#aa1e70',
            //   icon: 'mdi-music mdi-18px',
            //   text: 'وویس جدید',
            // });
            if (temp[i].mission.rank == 0) {
              rankIcon = 'mdi-numeric-4-circle mdi-18px';
              rankIconColor = '#D1D1D1';
            } else if (temp[i].mission.rank == 1) {
              rankIcon = 'mdi-numeric-3-circle mdi-18px';
              rankIconColor = '#3BCA79';
            } else if (temp[i].mission.rank == 2) {
              rankIcon = 'mdi-numeric-2-circle mdi-18px';
              rankIconColor = '#F2BD27';
            } else if (temp[i].mission.rank == 3) {
              rankIcon = 'mdi-numeric-1-circle mdi-18px';
              rankIconColor = '#F56060';
            }
            if (!temp[i].missionDelivered && !temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-timer-outline mdi-18px';
              recivedToPhoneStateColor = '#bb2e2e';
            } else if (temp[i].hasDoctor) {
              recivedToPhoneState = 'mdi-doctor mdi-18px';
              recivedToPhoneStateColor = '#959595';
            } else if (temp[i].missionDelivered && !temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-check mdi-18px';
              recivedToPhoneStateColor = 'yellow';
            } else if (temp[i].missionDelivered && temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-check-all mdi-18px';
              recivedToPhoneStateColor = '#1EAA6E';
            } else if (!temp[i].missionDelivered && temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-check-all mdi-18px';
              recivedToPhoneStateColor = '#1EAA6E';
            }

            if (temp[i].mission && temp[i].mission.creationUser) {
              let fName = temp[i].mission.creationUser.firstName
                ? temp[i].mission.creationUser.firstName
                : '-';
              let lName = temp[i].mission.creationUser.lastName
                ? temp[i].mission.creationUser.lastName
                : '-';
              // user = fName + ' ' + lName;
              const sipExtension = temp[i].mission?.creationUser?.sipExtension;
              user = `${fName} ${lName}${sipExtension ? `(${sipExtension})` : ''}`;
            }

            // if(temp[i].mission&&temp[i].mission.)
            if (temp[i].mission && temp[i].mission.callerId) {
              phone = temp[i].mission.callerId;
              patiantPhoneNumbers.push(phone);
              if (temp[i].mission && temp[i].mission.otherPhoneNumber) {
                phone += '-' + temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            } else {
              if (temp[i].mission && temp[i].mission.otherPhoneNumber) {
                phone = temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            }

            if (temp[i].hospital && temp[i].hospital.phoneNumber) {
              let tmpPhone = temp[i].hospital.phoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
              for (let j = 0; j < tmpPhone.length; j++) {
                hospitalPhoneNumbers_split.push(tmpPhone[j]);
              }
            }

            if (temp[i].id) {
              toopakId = temp[i].id.toString();
              toopakId = toopakId + temp[i].mission.id.toString();
            } else {
              toopakId = temp[i].mission.id.toString();
            }
            if (localStorage.getItem(toopakId)) {
              toopak = localStorage.getItem(toopakId);
              icon.push({
                type: 'toopak',
                color: toopak,
                icon: 'mdi-circle mdi-18px',
                text: 'برچسب دار',
              });
            } else {
              toopak = null;
            }
            //if (!toopak) {
            if (temp[i].patientPlaceDuration) {
              let moment = require('moment');
              let patiantMiniute = moment.duration(temp[i].patientPlaceDuration).asMinutes();
              if (patiantMiniute <= 20) {
                icon.push({
                  type: 'time',
                  color: '#1eaa6e',
                  icon: 'mdi-account mdi-18px',
                  text: 'ماندگاری بر بالین',
                });
              } else {
                icon.push({
                  type: 'time',
                  color: '#943a2d',
                  icon: 'mdi-account mdi-18px',
                  text: 'ماندگاری بر بالین',
                });
              }
            } else {
              icon.push({
                type: 'time',
                color: '#ffbd55',
                icon: 'mdi-account mdi-18px',
                text: 'ماندگاری بر بالین',
              });
            }
            if (temp[i].hospitalWaitingDuration) {
              let moment = require('moment');
              let hospitalMiniute = moment.duration(temp[i].hospitalWaitingDuration).asMinutes();

              if (hospitalMiniute <= 20) {
                icon.push({
                  type: 'time',
                  color: '#1eaa6e',
                  icon: 'mdi-hospital-building mdi-18px',
                  text: 'ماندگاری در بیمارستان',
                });
              } else {
                icon.push({
                  type: 'time',
                  color: '#943a2d',
                  icon: 'mdi-hospital-building mdi-18px',
                  text: 'ماندگاری در بیمارستان',
                });
              }
            } else {
              icon.push({
                type: 'time',
                color: '#ffbd55',
                icon: 'mdi-hospital-building mdi-18px',
                text: 'ماندگاری در بیمارستان',
              });
            }
            if (temp[i].mission.missionType == 1) {
              icon = [];
              icon.push({
                type: 'time',
                color: '#D1D1D1',
                icon: 'mdi-car-clock mdi-18px',
                text: 'ماموریت استقرار',
              });
            }
            //}
            this.bottomList.push({
              ambulanceCode: temp[i].phone ? temp[i].phone.code : '-',
              shabrangCode: temp[i].phone ? temp[i].phone.vehicleCode : '-',
              address: temp[i].mission ? temp[i].mission.address : '-',
              phoneNumber: phone,
              beforStatus: temp[i].dispatchPreviousState ? temp[i].dispatchPreviousState : '-',
              status: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              ambulanceStatus: temp[i].vehicleCurrentState ? temp[i].vehicleCurrentState : '-',
              patientsCount: temp[i]?.mission?.numberOfPatients ?? 1,
              phoneStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              markPhoneCurrentState: temp[i].markPhoneCurrentState ? temp[i].markPhoneCurrentState : false,
              hospital: temp[i].hospital ? temp[i].hospital.title : '-',
              cc:
                temp[i].mission &&
                  temp[i].mission.diagnosis &&
                  temp[i].mission.diagnosis.title
                  ? temp[i].mission.diagnosis.title
                  : '-',
              user: user,
              zone: temp[i].dispatchZone ? temp[i].dispatchZone.title : '-',
              missionId: temp[i].mission.id,
              id: temp[i].id,
              phoneId: temp[i].phone ? temp[i].phone.id : null,
              iconData: icon,
              hasAddressChanged: temp[i].mission ? temp[i].mission.hasAddressChanged : false,
              hasLackOfCode: temp[i].mission ? temp[i].mission.hasLackOfCode : false,
              recivedToPhoneState: recivedToPhoneState,
              recivedToPhoneStateColor: recivedToPhoneStateColor,
              patiantPhoneNumbers: patiantPhoneNumbers,
              codePhoneNumber: temp[i].phone ? temp[i].phone.phoneNumber : null,
              hospitalPhoneNumber: hospitalPhoneNumbers_split,
              hasUnsentAddressNotification: temp[i].hasUnsentAddressNotification,
              hasUnsentCcNotification: temp[i].hasUnsentCcNotification,
              hasUnsentStateNotification: temp[i].hasUnsentStateNotification,
              hasUnsentHospitalNotification: temp[i].hasUnsentHospitalNotification,
              rankIcon: rankIcon,
              rankIconColor: rankIconColor,
              toopakId: toopakId,
              phonePreviousState: temp[i]?.phonePreviousState,
              chiefComplaintText: temp[i]?.mission?.['chiefComplaintText'],
              ccNote:
                temp[i].mission && temp[i].mission.chiefComplaintNote
                  ? temp[i].mission.chiefComplaintNote
                  : '-',
            });

          }
          this.bottomListManualRefreshLoaderFlag = false;
          if (isManual) {
            try {
              const tables = document.getElementsByTagName('table');
              this.$root.$refs.Mission800View.resizableGrid(tables[1]);
              this.$root.$refs.Mission800View.onScroll()
            } catch (error) { console.log("AA error:", error); }
            try {
              const tables1 = document.getElementsByTagName('table');
              this.$root.$refs.currentMission800View.resizableGrid(tables1[0]);
              this.$root.$refs.currentMission800View.onScroll()
            } catch (error) { console.log("AA error:", error); }
          }

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.bottomListManualRefreshLoaderFlag = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfDispatchBottomListFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfDispatchBottomListFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfDispatchBottomListFunction: function (isManual = false) {
      // RETURN the promise chain — refreshBottomList() in both components awaits
      // this; without the return, the in-flight guard is blind
      return this.$store.dispatch('getDispatchBotoomList').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.dispatchBottomList;

          // hoisted out of the loop: was re-required up to twice PER ROW
          const moment = require('moment');
          // hoisted out of the loop: was re-assigned (reactively) once PER ROW
          this.listOf1024Missions = [];

          // build into a LOCAL array — pushing into the reactive this.bottomList
          // inside the loop fires watchers per item and flashes an empty table
          const rows = [];

          for (let i = 0; i < temp.length; i++) {
            let recivedToPhoneState = null;
            let recivedToPhoneStateColor = '';
            let user = '';
            let phone = '';
            let toopak = '';
            let toopakId = '';
            let icon = [];
            let patiantPhoneNumbers = [];
            let hospitalPhoneNumbers_split = [];
            let rankIcon = '';
            let rankIconColor = '';
            if (temp[i].mission.rank == 0) {
              rankIcon = 'mdi-numeric-4-circle mdi-18px';
              rankIconColor = '#D1D1D1';
            } else if (temp[i].mission.rank == 1) {
              rankIcon = 'mdi-numeric-3-circle mdi-18px';
              rankIconColor = '#3BCA79';
            } else if (temp[i].mission.rank == 2) {
              rankIcon = 'mdi-numeric-2-circle mdi-18px';
              rankIconColor = '#F2BD27';
            } else if (temp[i].mission.rank == 3) {
              rankIcon = 'mdi-numeric-1-circle mdi-18px';
              rankIconColor = '#F56060';
            }
            if (!temp[i].missionDelivered && !temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-timer-outline mdi-18px';
              recivedToPhoneStateColor = '#bb2e2e';
            } else if (temp[i].hasDoctor) {
              recivedToPhoneState = 'mdi-doctor mdi-18px';
              recivedToPhoneStateColor = '#959595';
            } else if (temp[i].missionDelivered && !temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-check mdi-18px';
              recivedToPhoneStateColor = 'yellow';
            } else if (temp[i].missionDelivered && temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-check-all mdi-18px';
              recivedToPhoneStateColor = '#1EAA6E';
            } else if (!temp[i].missionDelivered && temp[i].missionSeen) {
              recivedToPhoneState = 'mdi-check-all mdi-18px';
              recivedToPhoneStateColor = '#1EAA6E';
            }

            if (temp[i].mission && temp[i].mission.creationUser) {
              let fName = temp[i].mission.creationUser.firstName
                ? temp[i].mission.creationUser.firstName
                : '-';
              let lName = temp[i].mission.creationUser.lastName
                ? temp[i].mission.creationUser.lastName
                : '-';
              // user = fName + ' ' + lName;
              const sipExtension = temp[i].mission?.creationUser?.sipExtension;
              user = `${fName} ${lName}${sipExtension ? `(${sipExtension})` : ''}`;
            }

            if (temp[i].mission && temp[i].mission.callerId) {
              phone = temp[i].mission.callerId;
              patiantPhoneNumbers.push(phone);
              if (temp[i].mission && temp[i].mission.otherPhoneNumber) {
                phone += '-' + temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            } else {
              if (temp[i].mission && temp[i].mission.otherPhoneNumber) {
                phone = temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            }

            if (temp[i].hospital && temp[i].hospital.phoneNumber) {
              let tmpPhone = temp[i].hospital.phoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
              for (let j = 0; j < tmpPhone.length; j++) {
                hospitalPhoneNumbers_split.push(tmpPhone[j]);
              }
            }

            if (temp[i].id) {
              toopakId = temp[i].id.toString();
              toopakId = toopakId + temp[i].mission.id.toString();
            } else {
              toopakId = temp[i].mission.id.toString();
            }
            if (localStorage.getItem(toopakId)) {
              toopak = localStorage.getItem(toopakId);
              icon.push({
                type: 'toopak',
                color: toopak,
                icon: 'mdi-circle mdi-18px',
                text: 'برچسب دار',
              });
            } else {
              toopak = null;
            }
            if (temp[i].patientPlaceDuration) {
              let patiantMiniute = moment.duration(temp[i].patientPlaceDuration).asMinutes();
              if (patiantMiniute <= 20) {
                icon.push({
                  type: 'time',
                  color: '#1eaa6e',
                  icon: 'mdi-account mdi-18px',
                  text: 'ماندگاری بر بالین',
                });
              } else {
                icon.push({
                  type: 'time',
                  color: '#943a2d',
                  icon: 'mdi-account mdi-18px',
                  text: 'ماندگاری بر بالین',
                });
              }
            } else {
              icon.push({
                type: 'time',
                color: '#ffbd55',
                icon: 'mdi-account mdi-18px',
                text: 'ماندگاری بر بالین',
              });
            }
            if (temp[i].hospitalWaitingDuration) {
              let hospitalMiniute = moment.duration(temp[i].hospitalWaitingDuration).asMinutes();

              if (hospitalMiniute <= 20) {
                icon.push({
                  type: 'time',
                  color: '#1eaa6e',
                  icon: 'mdi-hospital-building mdi-18px',
                  text: 'ماندگاری در بیمارستان',
                });
              } else {
                icon.push({
                  type: 'time',
                  color: '#943a2d',
                  icon: 'mdi-hospital-building mdi-18px',
                  text: 'ماندگاری در بیمارستان',
                });
              }
            } else {
              icon.push({
                type: 'time',
                color: '#ffbd55',
                icon: 'mdi-hospital-building mdi-18px',
                text: 'ماندگاری در بیمارستان',
              });
            }
            if (temp[i].mission.missionType == 1) {
              icon = [];
              icon.push({
                type: 'time',
                color: '#D1D1D1',
                icon: 'mdi-car-clock mdi-18px',
                text: 'ماموریت استقرار',
              });
            }
            // each row frozen: Vue skips the deep reactivity walk over ~30 props
            // per row on every socket signal (rows are replaced wholesale)
            rows.push(Object.freeze({
              ambulanceCode: temp[i].phone ? temp[i].phone.code : '-',
              shabrangCode: temp[i].phone ? temp[i].phone.vehicleCode : '-',
              address: temp[i].mission ? temp[i].mission.address : '-',
              phoneNumber: phone,
              beforStatus: temp[i].dispatchPreviousState ? temp[i].dispatchPreviousState : '-',
              status: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              ambulanceStatus: temp[i].vehicleCurrentState ? temp[i].vehicleCurrentState : '-',
              patientsCount: temp[i]?.mission?.numberOfPatients ?? 1,
              phoneStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              markPhoneCurrentState: temp[i].markPhoneCurrentState ? temp[i].markPhoneCurrentState : false,
              hospital: temp[i].hospital ? temp[i].hospital.title : '-',
              cc:
                temp[i].mission &&
                  temp[i].mission.diagnosis &&
                  temp[i].mission.diagnosis.title
                  ? temp[i].mission.diagnosis.title
                  : '-',
              user: user,
              zone: temp[i].dispatchZone ? temp[i].dispatchZone.title : '-',
              missionId: temp[i].mission.id,
              id: temp[i].id,
              phoneId: temp[i].phone ? temp[i].phone.id : null,
              iconData: icon,
              hasAddressChanged: temp[i].mission ? temp[i].mission.hasAddressChanged : false,
              hasLackOfCode: temp[i].mission ? temp[i].mission.hasLackOfCode : false,
              recivedToPhoneState: recivedToPhoneState,
              recivedToPhoneStateColor: recivedToPhoneStateColor,
              patiantPhoneNumbers: patiantPhoneNumbers,
              codePhoneNumber: temp[i].phone ? temp[i].phone.phoneNumber : null,
              hospitalPhoneNumber: hospitalPhoneNumbers_split,
              hasUnsentAddressNotification: temp[i].hasUnsentAddressNotification,
              hasUnsentCcNotification: temp[i].hasUnsentCcNotification,
              hasUnsentStateNotification: temp[i].hasUnsentStateNotification,
              hasUnsentHospitalNotification: temp[i].hasUnsentHospitalNotification,
              rankIcon: rankIcon,
              rankIconColor: rankIconColor,
              toopakId: toopakId,
              phonePreviousState: temp[i]?.phonePreviousState,
              chiefComplaintText: temp[i]?.mission?.['chiefComplaintText'],
              ccNote:
                temp[i].mission && temp[i].mission.chiefComplaintNote
                  ? temp[i].mission.chiefComplaintNote
                  : '-',
            }));
          }

          // ONE reactive assignment -> exactly one re-render, no mid-loop flicker
          this.bottomList = Object.freeze(rows);

          this.bottomListManualRefreshLoaderFlag = false;
          if (isManual) {
            // The rewritten resizableGrid/onScroll use listeners that SURVIVE data
            // refreshes, so re-running them on the same DOM would duplicate resize
            // handles and delegated listeners. The dataset flags make init run at
            // most once per DOM node; after a header sort the table DOM is
            // re-created (flag gone), so re-init still happens where it should.
            try {
              const tables = document.getElementsByTagName('table');
              if (tables[1] && !tables[1].dataset.resizableInit) {
                tables[1].dataset.resizableInit = '1';
                this.$root.$refs.Mission800View.resizableGrid(tables[1]);
                this.$root.$refs.Mission800View.onScroll();
              }
            } catch (error) { console.log("AA error:", error); }
            try {
              const tables1 = document.getElementsByTagName('table');
              if (tables1[0] && !tables1[0].dataset.resizableInit) {
                tables1[0].dataset.resizableInit = '1';
                this.$root.$refs.currentMission800View.resizableGrid(tables1[0]);
                this.$root.$refs.currentMission800View.onScroll();
              }
            } catch (error) { console.log("AA error:", error); }
          }

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.bottomListManualRefreshLoaderFlag = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            // RETURN the retry chain (awaiting callers wait for it) and PRESERVE
            // the isManual argument (old code silently reset it to false)
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getListOfDispatchBottomListFunction(isManual);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getListOfDispatchBottomListFunction(isManual);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    getMissionBy800Function: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionBy800User', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.missionPhoneModule.dispatchMission;
          if (temp.hospital) {
            this.hasHospitalFlag = true;
          } else {
            this.hasHospitalFlag = false;
          }
          this.save_dispatchCurrentState = temp.dispatchCurrentState
          this.save_hospitalId = temp?.hospital?.id

          if (temp.dispatchCurrentState?.length > 0) {
            this.hasStatusFlag = true;
          } else {
            this.hasStatusFlag = false;
          }
          this.missionInformation = new EditMissionModel.EditMission(
            temp.id,
            temp.dispatchCurrentState,
            temp.hospital ? temp.hospital.id : null,
            [],
            temp.mission && temp.mission.city ? temp.mission.city.id : null,
            temp.mission ? temp.mission.address : '',
            temp.dispatchZone ? temp.dispatchZone.id : null,
            temp.editableByFollowUp,
            temp.allow1019,
            temp.is247,
            temp.is724,
            temp.mission && temp.mission.geographicalType ? temp.mission.geographicalType.id : null,
            temp.isDeployed,
            '',
            [],
            null,
          );
          if (temp.mission) {
            for (let i = 0; i < temp.mission.missionTags.length; i++) {
              this.missionInformationTagList.push(temp.mission.missionTags[i].tag.id);
            }
            for (let i = 0; i < temp.mission.missionLackOfCodes.length; i++) {
              this.listOfMissionLakeCodeStation.push({
                title: temp.mission.missionLackOfCodes[i].station.title,
                titleCode: temp.mission.missionLackOfCodes[i].station.title + "(" + temp.mission.missionLackOfCodes[i].station.code + ")",
                id: temp.mission.missionLackOfCodes[i].station.id,
              });
            }
            for (let i = 0; i < temp.mission.callerIds.length; i++) {
              if (temp.mission.callerIds[i]?.trim()?.length > 0) {
                this.listOfMissionCallerIds.push(temp.mission.callerIds[i]);
              }
            }
            if (temp.mission.latitude) {
              this.mainPationtPosition = {
                lat: temp.mission.latitude,
                lng: temp.mission.longitude,
              };
              this.patiantPosition = {
                lat: temp.mission.latitude,
                lng: temp.mission.longitude,
              };
            }
          }
          if (temp.dispatchCurrentState) {
            let dispatchCodeFalg = false;
            if (this.allDispatchCodesForOther.find((e) => e.title === temp.dispatchCurrentState)) {
              dispatchCodeFalg = true;
            }
            if (dispatchCodeFalg == false) {
              this.allDispatchCodesForOther.unshift({
                title: temp.dispatchCurrentState,
                hasNotification: true,
                id: 0,
                isActive: true,
              });
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionBy800Function(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionBy800Function(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    modifyMissionBy800UserFunction: function () {
      if (!this.missionInformation.cityId) {
        this.showErrorAlert('شهر نمی تواند خالی باشد.');
        return;
      }
      // if (
      //   !this.was1019 &&
      //   (this.missionInformation.allow1019 || this.wasDispatchState1019) &&
      //   !this.editMissionTenNineteenNote
      // ) {

      //   this.showErrorAlert("دلیل انصراف را مشخص کنید.");
      //   return;
      // }
      if (!this.missionInformation.address) {
        this.showErrorAlert('آدرس نمی تواند خالی باشد.');
        return;
      } else if (!this.was)
        if (!this.load.val) {
          this.load.val = true;
        }
      if (this.missionInformation.allow1019 === null) {
        this.missionInformation.allow1019 = false;
      }
      if (this.missionInformation.is247 === null) {
        this.missionInformation.is247 = false;
      }
      if (this.missionInformation.is724 === null) {
        this.missionInformation.is724 = false;
      }
      if (this.missionInformation.isDeployed === null) {
        this.missionInformation.isDeployed = false;
      }
      /*if (this.missionInformation.isWithinCity === null) {
                this.missionInformation.isWithinCity = false;
            }*/
      if (this.missionInformation.editableByFollowUp === null) {
        this.missionInformation.editableByFollowUp = false;
      }
      if (this.missionInformation.dispatchCurrentState === null) {
        this.missionInformation.dispatchCurrentState = '';
      }
      this.missionInformation.missionLackOfCodes = [...this.listOfMissionLakeCodeStation]?.map(
        ({ id }) => ({ missionId: this.missionId, stationId: id }),
      );

      this.missionInformation.missionTags = [...this.missionInformationTagList]?.map((id) => ({
        tagId: id,
      }));

      // set missionCancelReason in 10-19
      this.missionInformation.missionCancelReason = this.editMissionTenNineteenNote;
      const uniqueId = this.$root.$refs.Home?.uniqueId ?? null;
      this.missionInformation.uniqueId = uniqueId;
      this.$store.dispatch('modifyMissionBy800User', this.missionInformation).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.setUniqueId();
          this.$root.$refs?.Mission800View?.closeEditModal();
          this.$root.$refs?.currentMission800View?.closeEditModal();
          this.changeToOldTitle();
          this.listOfMissionLakeCodeStation = [];
          this.missionInformationTagList = [];
          this.missionInformation = new EditMissionModel.EditMission(
            null,
            '',
            null,
            [],
            null,
            '',
            null,
            false,
            false,
            false,
            false,
            null,
            false,
            '',
            [],
            null,
          );
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.modifyMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.modifyMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    // start triage
    getAllMissionStartTriages: function (missionPhoneId) {
      this.load.val = true;
      const params = { missionPhoneId };
      this.$store
        .dispatch('getStartTriagesListDispatch', params)
        .then(() => {
          if (this.$store.state.missionPhoneModule.successFlag) {
            const temp = this.$store.state.missionPhoneModule.allMissionStartTriages;
            this.allMissionStartTriages = temp;
          } else {
            if (this.$store.state.missionPhoneModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllMissionStartTriages(missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionPhoneModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllMissionStartTriages(missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    // end start triage
    // modifyMissionBy800UserFunction
    getMissionPhoneFenceTimeFuntion: function (missionPhoneId, mianTimes) {
      this.$store.dispatch('getMissionFenceTimesBy800User', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.fenceTime;
          if (this.editTab == 'time') {
            this.readyTimeData(temp, mianTimes);
          }
          if (this.$route.name == 'dashboardFollowUp') {
            //نمایش زمان های ماموریت در داشبورد پیگیری
            this.readyTimeData(temp, mianTimes);
          }
          if (this.$route.name == 'missionReport') {
            //گزارش پرونده
            this.readyTimeData(temp, mianTimes);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneFenceTimeFuntion(missionPhoneId, mianTimes);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneFenceTimeFuntion(missionPhoneId, mianTimes);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //setm times ************************************************************************************
    setMoveFromStationTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setMoveFromStationTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان حرکت از پایگاه با موفقیت ثبت شد');
          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setMoveFromStationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setMoveFromStationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setArriveToLocationTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setArriveToLocationTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان رسیدن به فوریت با موفقیت ثبت شد');
          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setArriveToLocationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setArriveToLocationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setMoveFromLocationTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setMoveFromLocationTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان حرکت از فوریت با موفقیت ثبت شد');
          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setMoveFromLocationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setMoveFromLocationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setArriveToHospitalTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setArriveToHospitalTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان رسیدن به بیمارستان با موفقیت ثبت شد');
          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setArriveToHospitalTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setArriveToHospitalTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setFinishTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setFinishTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان با موفقیت ثبت شد');

          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setFinishTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setFinishTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setPatientDeliveryTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setPatientDeliveryTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان تحویل بیمار با موفقیت ثبت شد');
          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setPatientDeliveryTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setPatientDeliveryTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setArriveToStationTimeFunction: function (missionPhoneId) {
      this.$store.dispatch('setArriveToStationTime', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert('زمان رسیدن به پایگاه با موفقیت ثبت شد');
          this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
          this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        } else {
          this.disabelConfirm = false;
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setArriveToStationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setArriveToStationTimeFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //admission ************************************************************************* admission ***
    getListOfCurrentMissionsForAdmissionFunction_OOLLDD: function (islaod = true) {
      if (!this.load.val && islaod) {
        this.load.val = true;
      }
      this.$store.dispatch('getCurrentMissionsForAdmission').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.admissionMissions;
          for (let i = 0; i < this.stayInHospitalList.length; i++) {
            clearInterval(this.stayInHospitalList[i].timeInterval);
          }
          this.admissionTopList = [];
          this.stayInHospitalList = [];
          for (let i = 0; i < temp.length; i++) {
            let rank = '';
            let iconColor = '';
            let iconClass = '';
            let hospitalPhoneNumbers_split = [];
            if (temp[i].mission.rank == 0) {
              rank = 'سفید';
              iconColor = '#D1D1D1';
              iconClass = '';
            } else if (temp[i].mission.rank == 1) {
              rank = 'سبز';
              iconColor = '#3BCA79';
              iconClass = '';
            } else if (temp[i].mission.rank == 2) {
              rank = 'زرد';
              iconColor = '#F2BD27';
              iconClass = 'rank-icon-anim2';
            } else if (temp[i].mission.rank == 3) {
              rank = 'قرمز';
              iconColor = '#F56060';
              iconClass = 'rank-icon-anim1';
            }

            if (temp[i].hospital && temp[i].hospital.phoneNumber) {
              let tmpPhone = temp[i].hospital.phoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
              for (let j = 0; j < tmpPhone.length; j++) {
                hospitalPhoneNumbers_split.push(tmpPhone[j]);
              }
            }

            this.admissionTopList.push({
              id: temp[i].id,
              codePhoneNumbers:
                temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '',
              city:
                temp[i].mission && temp[i].mission.city && temp[i].mission.city.title
                  ? temp[i].mission.city.title
                  : '-',
              address: temp[i].mission && temp[i].mission.address ? temp[i].mission.address : '-',
              ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
              shabrang:
                temp[i].phone && temp[i].phone.vehicleCode ? temp[i].phone.vehicleCode : '-',
              cc:
                temp[i].mission && temp[i].mission.chiefComplaintText
                  ? temp[i].mission.chiefComplaintText
                  : '-',
              hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              codeStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              missionStatus: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              cheifComplaint:
                temp[i].mission && temp[i].mission.diagnosis
                  ? temp[i].mission.diagnosis.title
                  : '-',
              phoneNumber:
                temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '-',
              rank: rank,
              iconColor: iconColor,
              iconClass: iconClass,
              phoneId: temp[i].phone && temp[i].phone.id ? temp[i].phone.id : '-',
              hospitalPhoneNumber_mission: hospitalPhoneNumbers_split,
              markPhoneCurrentState: temp[i].markPhoneCurrentState ? temp[i].markPhoneCurrentState : false,
            });
            if (temp[i].hospitalWatingDuration) {
              let moment = require('moment');
              let hospitalMiniute = moment.duration(temp[i].hospitalWatingDuration).asMinutes();
              if (hospitalMiniute >= 20) {
                let duration = Number(hospitalMiniute) * 60;
                duration = duration * 1000;
                this.stayInHospitalList.push({
                  id: temp[i].id,
                  ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
                  time: hospitalMiniute,
                  timeInterval: null,
                });
                const index = this.stayInHospitalList.length - 1;
                this.stayInHospitalList[index].timeInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.stayInHospitalList[index].time = this.msToTime(duration);
                }, 1000);
              }
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfCurrentMissionsForAdmissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfCurrentMissionsForAdmissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfCurrentMissionsForAdmissionFunction: function (islaod = true) {
      if (!this.load.val && islaod) {
        this.load.val = true;
      }
      return this.$store.dispatch('getCurrentMissionsForAdmission').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          const temp = this.$store.state.missionPhoneModule.admissionMissions;

          // stop old per-row timers before rebuilding
          for (let i = 0; i < this.stayInHospitalList.length; i++) {
            clearInterval(this.stayInHospitalList[i].timeInterval);
          }

          const topRows = [];
          const stayRows = [];

          for (let i = 0; i < temp.length; i++) {
            let rank = '';
            let phone = '';
            let iconColor = '';
            let iconClass = '';
            const hospitalPhoneNumbers_split = [];
            let patiantPhoneNumbers = [];

            if (temp[i].mission.rank == 0) {
              rank = 'سفید';
              iconColor = '#D1D1D1';
              iconClass = '';
            } else if (temp[i].mission.rank == 1) {
              rank = 'سبز';
              iconColor = '#3BCA79';
              iconClass = '';
            } else if (temp[i].mission.rank == 2) {
              rank = 'زرد';
              iconColor = '#F2BD27';
              iconClass = 'rank-icon-anim2';
            } else if (temp[i].mission.rank == 3) {
              rank = 'قرمز';
              iconColor = '#F56060';
              iconClass = 'rank-icon-anim1';
            }

            if (temp[i].hospital && temp[i].hospital.phoneNumber) {
              const tmpPhone = temp[i].hospital.phoneNumber
                ?.replace(/[-_,.\s]/g, ' ')
                .split(' ');
              for (let j = 0; j < tmpPhone.length; j++) {
                hospitalPhoneNumbers_split.push(tmpPhone[j]);
              }
            }

            if (temp[i].mission.callerId) {
              phone = temp[i].mission.callerId;
              patiantPhoneNumbers.push(phone);
              if (temp[i].mission.otherPhoneNumber) {
                phone += ' - ' + temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            } else if (temp[i].mission.otherPhoneNumber) {
              phone = temp[i].mission.otherPhoneNumber;
              let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
              for (let j = 0; j < tmpPhone.length; j++) {
                if (tmpPhone[j]) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            }

            // frozen: these rows are display-only, never mutated afterwards
            topRows.push(
              Object.freeze({
                id: temp[i].id,
                missionId: temp[i].mission.id,
                codePhoneNumbers:
                  temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '',
                city:
                  temp[i].mission && temp[i].mission.city && temp[i].mission.city.title
                    ? temp[i].mission.city.title
                    : '-',
                address: temp[i].mission && temp[i].mission.address ? temp[i].mission.address : '-',
                ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
                shabrang:
                  temp[i].phone && temp[i].phone.vehicleCode ? temp[i].phone.vehicleCode : '-',
                cc:
                  temp[i].mission && temp[i].mission.chiefComplaintText
                    ? temp[i].mission.chiefComplaintText
                    : '-',
                hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
                codeStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
                missionStatus: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
                cheifComplaint:
                  temp[i].mission && temp[i].mission.diagnosis
                    ? temp[i].mission.diagnosis.title
                    : '-',
                phoneNumber:
                  temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '-',
                rank: rank,
                iconColor: iconColor,
                iconClass: iconClass,
                phoneId: temp[i].phone && temp[i].phone.id ? temp[i].phone.id : '-',
                hospitalPhoneNumber_mission: hospitalPhoneNumbers_split,
                markPhoneCurrentState: temp[i].markPhoneCurrentState
                  ? temp[i].markPhoneCurrentState
                  : false,
                patiantPhoneNumbers: patiantPhoneNumbers,
              }),
            );

            if (temp[i].hospitalWatingDuration) {
              const moment = require('moment');
              const hospitalMiniute = moment
                .duration(temp[i].hospitalWatingDuration)
                .asMinutes();
              if (hospitalMiniute >= 20) {
                let duration = Number(hospitalMiniute) * 60 * 1000;

                // NOT frozen — `time` is mutated by the interval below
                const row = {
                  id: temp[i].id,
                  ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
                  time: hospitalMiniute,
                  timeInterval: null,
                };
                // closure captures the row object itself — no index lookups
                row.timeInterval = setInterval(() => {
                  duration = duration + 1000;
                  row.time = this.msToTime(duration);
                }, 1000);
                stayRows.push(row);
              }
            }
          }

          // single reactive assignment each — one re-render per list
          this.admissionTopList = Object.freeze(topRows);
          this.stayInHospitalList = stayRows;

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getListOfCurrentMissionsForAdmissionFunction(islaod);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getListOfCurrentMissionsForAdmissionFunction(islaod);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionForAssignHospitalFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionForAssignHospital', this.missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.missionAssignInfo;
          this.missionId = temp.mission.id;
          this.missionSendToHospitalInfo.address =
            temp.mission && temp.mission.address ? temp.mission.address : '-';
          this.missionSendToHospitalInfo.rank = temp.mission.rank;
          this.missionSendToHospitalInfo.ambulanceCode =
            temp.phone && temp.phone.code ? temp.phone.code : '-';
          this.missionSendToHospitalInfo.chiefComplaint =
            temp.mission && temp.mission.chiefComplaintText ? temp.mission.chiefComplaintText : '-';
          this.missionSendToHospitalInfo.admission = temp.diagnosisForHospitalRequest
            ? temp.diagnosisForHospitalRequest
            : '-';
          this.missionSendToHospitalInfo.shabrang =
            temp.phone && temp.phone.vehicleCode ? temp.phone.vehicleCode : '-';
          this.missionSendToHospitalInfo.codeStatus = temp.phoneCurrentState
            ? temp.phoneCurrentState
            : '-';
          this.missionSendToHospitalInfo.phoneNumber =
            temp.phone && temp.phone.phoneNumber ? temp.phone.phoneNumber : '-';
          this.selectedHospital = temp.hospital ? temp.hospital.id : null;
          if (temp.hospital) {
            this.hasHospital = true;
            this.lastHospital = temp.hospital.id;
          }
          if (temp.mission.rank == 0) {
            this.missionSendToHospitalInfo.rankText = '4-سفید';
            this.missionRankIconClass = 'mx-2';
            this.missionRankIconColor = '';
          } else if (temp.mission.rank == 1) {
            this.missionSendToHospitalInfo.rankText = '3-سبز';
            this.missionRankIconClass = 'mx-2';
            this.missionRankIconColor = '#3BCA79';
          } else if (temp.mission.rank == 2) {
            this.missionSendToHospitalInfo.rankText = '2-زرد';
            this.missionRankIconClass = 'rank-icon-anim2 mx-2';
            this.missionRankIconColor = '#F2BD27';
          } else if (temp.mission.rank == 3) {
            this.missionSendToHospitalInfo.rankText = '1-قرمز';
            this.missionRankIconClass = 'rank-icon-anim1 mx-2';
            this.missionRankIconColor = '#F56060';
          }
          this.selectedTagsList = [];
          for (let i = 0; i < temp.mission.missionTags.length; i++) {
            this.selectedTagsList.push({
              tag: temp.mission.missionTags[i].tag,
              id: temp.mission.missionTags[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionForAssignHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionForAssignHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    sendMissionToHospitalFunction: function (body, onSuccess) {
      const data = {
        hospitalId: body?.selectedHospital || this?.selectedHospital,
        changeNote: body?.changeHospitalNote || this?.changeHospitalNote,
        missionPhoneId: this?.missionPhoneId || body?.missionPhoneId,
      };
      this.load.val = true;
      this.$store.dispatch('sendMissionToHospital', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'admissionMissions') {
            this.cleanForm();
            this.mounte();
          }
          if (this.$route.name == 'doctorMissions') {
            this.changeHospitalNote = '';
            onSuccess();
            this.getMissionPhoneByDoctorFunction(this.missionPhoneId);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.sendMissionToHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.sendMissionToHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    removeHospitalFunction: function (note, id) {
      if (!note) {
        this.snackText = 'توضیحات را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!note.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        cancelReason: note,
        missionPhoneId: id,
      };
      this.$store.dispatch('removeHospitalByAdmission', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.cleanForm();
          this.cancleCancleResoneHospital();
          this.mounte();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //doctor ************************************************************************************* doctor ***
    getListOfCurrentMissionsForDoctorFunction_OOLLDD: function (showLoad) {
      if (showLoad && !this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getCurrentMissionsForDoctor').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.doctorMissions;
          this.doctorMissions = [];
          for (let i = 0; i < temp.length; i++) {
            let rank = '';
            let iconColor = '';
            let iconClass = '';
            let user115 = '';
            if (temp[i].mission.creationUser) {
              user115 = `${temp[i].mission.creationUser.firstName} ${temp[i].mission.creationUser.lastName}`;
            }
            if (temp[i].mission.rank == 0) {
              rank = 'سفید';
              iconColor = '#D1D1D1';
              iconClass = '';
            } else if (temp[i].mission.rank == 1) {
              rank = 'سبز';
              iconColor = '#3BCA79';
              iconClass = '';
            } else if (temp[i].mission.rank == 2) {
              rank = 'زرد';
              iconColor = '#F2BD27';
              iconClass = 'rank-icon-anim2';
            } else if (temp[i].mission.rank == 3) {
              rank = 'قرمز';
              iconColor = '#F56060';
              iconClass = 'rank-icon-anim1';
            }
            this.doctorMissions.push({
              id: temp[i].id,
              city:
                temp[i].mission && temp[i].mission.city && temp[i].mission.city.title
                  ? temp[i].mission.city.title
                  : '-',
              address: temp[i].mission && temp[i].mission.address ? temp[i].mission.address : '-',
              ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
              cc:
                temp[i].mission && temp[i].mission.chiefComplaintText
                  ? temp[i].mission.chiefComplaintText
                  : '-',
              hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              ambulanceStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              missionStatus: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              phoneNumber:
                temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '-',
              rank: rank,
              iconColor: iconColor,
              iconClass: iconClass,
              phoneId: temp[i].phone && temp[i].phone.id ? temp[i].phone.id : '-',
              chiefComplaintNote:
                temp[i].mission && temp[i].mission.chiefComplaintNote
                  ? temp[i].mission.chiefComplaintNote
                  : '-',
              missionId: temp[i].mission ? temp[i].mission.id : null,
              user115: user115,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfCurrentMissionsForDoctorFunction(showLoad);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfCurrentMissionsForDoctorFunction(showLoad);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfCurrentMissionsForDoctorFunction: function (showLoad) {
      if (showLoad && !this.load.val) {
        this.load.val = true;
      }
      // RETURN the promise chain — refreshDoctorList() in the component awaits
      // this; without the return, the in-flight guard is blind
      return this.$store.dispatch('getCurrentMissionsForDoctor').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          let temp = this.$store.state.missionPhoneModule.doctorMissions;

          // build into a LOCAL array — pushing into the reactive
          // this.doctorMissions inside the loop fires watchers per item
          // and flashes an empty table before refilling
          const rows = [];

          for (let i = 0; i < temp.length; i++) {
            let rank = '';
            let iconColor = '';
            let iconClass = '';
            let user115 = '';
            let phone = '';
            let patiantPhoneNumbers = [];
            if (temp[i].mission.creationUser) {
              user115 = `${temp[i].mission.creationUser.firstName} ${temp[i].mission.creationUser.lastName}`;
            }
            if (temp[i].mission.rank == 0) {
              rank = 'سفید';
              iconColor = '#D1D1D1';
              iconClass = '';
            } else if (temp[i].mission.rank == 1) {
              rank = 'سبز';
              iconColor = '#3BCA79';
              iconClass = '';
            } else if (temp[i].mission.rank == 2) {
              rank = 'زرد';
              iconColor = '#F2BD27';
              iconClass = 'rank-icon-anim2';
            } else if (temp[i].mission.rank == 3) {
              rank = 'قرمز';
              iconColor = '#F56060';
              iconClass = 'rank-icon-anim1';
            }

            if (temp[i].mission.callerId) {
              phone = temp[i].mission.callerId;
              patiantPhoneNumbers.push(phone);
              if (temp[i].mission.otherPhoneNumber) {
                phone += ' - ' + temp[i].mission.otherPhoneNumber;
                let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            } else if (temp[i].mission.otherPhoneNumber) {
              phone = temp[i].mission.otherPhoneNumber;
              let tmpPhone = temp[i].mission.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
              for (let j = 0; j < tmpPhone.length; j++) {
                if (tmpPhone[j]) {
                  patiantPhoneNumbers.push(tmpPhone[j]);
                }
              }
            }

            // each row frozen: Vue skips the deep reactivity walk on every
            // socket signal (rows are replaced wholesale, never mutated)
            rows.push(Object.freeze({
              id: temp[i].id,
              city:
                temp[i].mission && temp[i].mission.city && temp[i].mission.city.title
                  ? temp[i].mission.city.title
                  : '-',
              address: temp[i].mission && temp[i].mission.address ? temp[i].mission.address : '-',
              ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
              cc:
                temp[i].mission && temp[i].mission.chiefComplaintText
                  ? temp[i].mission.chiefComplaintText
                  : '-',
              hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              ambulanceStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              missionStatus: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              phoneNumber:
                temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '-',
              rank: rank,
              iconColor: iconColor,
              iconClass: iconClass,
              phoneId: temp[i].phone && temp[i].phone.id ? temp[i].phone.id : '-',
              chiefComplaintNote:
                temp[i].mission && temp[i].mission.chiefComplaintNote
                  ? temp[i].mission.chiefComplaintNote
                  : '-',
              missionId: temp[i].mission ? temp[i].mission.id : null,
              user115: user115,
              patiantPhoneNumbers: patiantPhoneNumbers,
              codePhoneNumbers:
                temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '',

            }));
          }

          // ONE reactive assignment -> exactly one re-render, no mid-loop flicker
          this.doctorMissions = Object.freeze(rows);

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            // RETURN the retry chain so awaiting callers wait for it too
            // (showLoad was already correctly preserved here)
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getListOfCurrentMissionsForDoctorFunction(showLoad);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getListOfCurrentMissionsForDoctorFunction(showLoad);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    getMissionPhoneByDoctorFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDoctorSelectedCodeFromMissionPhone', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.missionInfo = this.$store.state.missionPhoneModule.doctorMission;
          this.transformInfo(this.missionInfo);
          if (this.missionInfo.mission) {
            this.missionInfo.mission.creationDate = Vue.moment(
              this.missionInfo.mission.creationDate,
            ).format('HH:mm:ss jYYYY/jM/jD');
          }
          if (this.missionInfo.patients.length) {
            this.hasPatiantFlag = true;

            this.missionInfo.patients.forEach((c) => (c.class = 'not-selected-patiant mt-2'));
            this.missionInfo.patients[0].class = 'selected-patiant mt-2';
            this.patientId = this.missionInfo.patients[0].id;
            // this.getPatientFunction(this.missionInfo.patients[0].id);
          } else {
            this.getPatientDoctorDetailActiveInfoFunction(null, missionPhoneId);
          }
          if (this.missionInfo.hospital) {
            this.hasHospital = true;
            this.selectedHospital = this.missionInfo.hospital.id;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneByDoctorFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneByDoctorFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //follow up ******************************************************************
    transformData: function (data) {
      const classFields = (missionRank) => {
        const fields = {
          cardClass: '',
          sectionClass: '',
          stateClass: '',
        };
        switch (missionRank) {
          case 0:
            fields.cardClass = 'main-card-followup-dashboard-white';
            fields.sectionClass =
              'mobile-header-white animate__animated animate__rotateInDownRight';
            fields.stateClass = 'ml-1 mission-state-text-white';
            break;
          case 1:
            fields.cardClass = 'main-card-followup-dashboard-green';
            fields.sectionClass =
              'mobile-header-green animate__animated animate__rotateInDownRight';
            fields.stateClass = 'ml-1 mission-state-text-green';
            break;
          case 2:
            fields.cardClass = 'main-card-followup-dashboard-yellow';
            fields.sectionClass =
              'mobile-header-yellow animate__animated animate__rotateInDownRight';
            fields.stateClass = 'ml-1 mission-state-text-yellow';
            break;
          case 3:
            fields.cardClass = 'main-card-followup-dashboard-red';
            fields.sectionClass = 'mobile-header-red animate__animated animate__rotateInDownRight';
            fields.stateClass = 'ml-1 mission-state-text-red';
            break;

          default:
            fields.cardClass = '';
            fields.sectionClass = '';
            fields.stateClass = '';
            break;
        }
        return fields;
      };
      const setDurationStatesRecord = (duration, durationState, time = null) => {
        const stateObj = {
          time,
          duration,
          color: '',
          progressColor: '',
        };
        if (duration) {
          switch (durationState) {
            case null:
              stateObj.color = '#F28810';
              stateObj.progressColor = '#F28810';
              break;
            case false:
              stateObj.color = '#97462F';
              stateObj.progressColor = '#97462F';
              break;

            default:
              stateObj.color = '#0BA875';
              stateObj.progressColor = '#0BA875';
              break;
          }
        } else {
          stateObj.color = '#907C79';
          stateObj.progressColor = '#ffffff';
        }
        return stateObj;
      };
      return [...data]?.map((item) => {
        const {
          phoneCurrentState,
          missionRank,
          arriveToLocationTime,
          moveFromLocationTime,
          moveFromStationTime,
          seenTime,
          finishTime,
          arriveToHospitalTime,
          missionDuration,
          patientVisitDuration,
          moveFromStationDuration,
          arriveToLocationDuration,
          arriveToHospitalDuration,
          hospitalWaitingDuration,
          seenDuration,
          patientVisitDurationState,
          arriveToHospitalDurationState,
          hospitalWaitingDurationState,
          arriveToLocationDurationState,
          moveFromStationDurationState,
          seenDurationState,
          phoneCode,
          id,
          missionId,
          phoneId,
          dispatchCurrentState,
          phonePhoneNumber,
          missionCallerId,
          missionOtherPhoneNumber
        } = item;
        const classItems = classFields(missionRank);

        let title = phoneCurrentState;
        // ----- set state records----
        const hospitalWaiting = setDurationStatesRecord(
          hospitalWaitingDuration,
          hospitalWaitingDurationState,
          finishTime,
        );
        const arriveToHospital = setDurationStatesRecord(
          arriveToHospitalDuration,
          arriveToHospitalDurationState,
          arriveToHospitalTime,
        );
        const patientVisit = setDurationStatesRecord(
          patientVisitDuration,
          patientVisitDurationState,
          moveFromLocationTime,
        );
        const arriveToLocation = setDurationStatesRecord(
          arriveToLocationDuration,
          arriveToLocationDurationState,
          arriveToLocationTime,
        );
        const moveFromStation = setDurationStatesRecord(
          moveFromStationDuration,
          moveFromStationDurationState,
          moveFromStationTime,
        );
        const seenDurationRecord = setDurationStatesRecord(
          seenDuration,
          seenDurationState,
          seenTime,
        );
        const patientPhoneNumbers = []
        if (missionCallerId && missionCallerId.length > 0) {
          patientPhoneNumbers.push(missionCallerId)
        }

        if (missionOtherPhoneNumber && missionOtherPhoneNumber.length > 0) {
          const phones = Array.isArray(missionOtherPhoneNumber)
            ? missionOtherPhoneNumber
            : String(missionOtherPhoneNumber).split(/[,\s]+/);

          phones
            .map(p => String(p).trim())
            .filter(p => p !== '')
            .forEach(p => patientPhoneNumbers.push(p));
        }

        return {
          title,
          phoneId,
          missionDuration,
          hospitalWaiting,
          arriveToHospital,
          patientVisit,
          arriveToLocation,
          moveFromStation,
          phoneCurrentState,
          dispatchCurrentState,
          id,
          missionId,
          seenDurationRecord,
          code: phoneCode,
          ...classItems,
          phonePhoneNumber: phonePhoneNumber,
          patientPhoneNumbers: patientPhoneNumbers
        };
      });
    },
    getMissionPhoneFollowUpDashboardFunction: function (isLoading = true) {
      if (!this.load.val && isLoading) {
        this.load.val = true;
      }
      return this.$store.dispatch('getMissionPhoneFollowUpDashboard').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          const data = this.$store.state.missionPhoneModule.followUpDashboard;
          this.currentFollowUpCodesList = [...this.transformData(data)];
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneFollowUpDashboardFunction(isLoading);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneFollowUpDashboardFunction(isLoading);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionsByFollowUpFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionsByFollowUp').then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.missionPhoneModule.followUpMissions;
          this.followUpMissions = [];
          for (let i = 0; i < temp.length; i++) {
            let phoneNumber = '-';
            let user = '-';
            let rank = '';
            let iconColor = '';
            let iconClass = '';
            if (temp[i].mission) {
              if (temp[i].mission.callerId) {
                phoneNumber = temp[i].mission.callerId;
                if (temp[i].mission.otherPhoneNumber) {
                  phoneNumber = phoneNumber + ' ، ' + temp[i].mission.otherPhoneNumber;
                }
              } else if (temp[i].mission.otherPhoneNumber) {
                phoneNumber = temp[i].mission.otherPhoneNumber;
              }
              if (temp[i].mission.creationUser) {
                let fName = temp[i].mission.creationUser.firstName;
                let lName = temp[i].mission.creationUser.lastName;
                user = fName + ' ' + lName;
              }
              if (temp[i].mission.rank == 0) {
                rank = 'سفید';
                iconColor = '#D1D1D1';
                iconClass = '';
              } else if (temp[i].mission.rank == 1) {
                rank = 'سبز';
                iconColor = '#3BCA79';
                iconClass = '';
              } else if (temp[i].mission.rank == 2) {
                rank = 'زرد';
                iconColor = '#F2BD27';
                iconClass = 'rank-icon-anim2';
              } else if (temp[i].mission.rank == 3) {
                rank = 'قرمز';
                iconColor = '#F56060';
                iconClass = 'rank-icon-anim1';
              }
            }
            this.followUpMissions.push({
              id: temp[i].id,
              city:
                temp[i].mission && temp[i].mission.city && temp[i].mission.city
                  ? temp[i].mission.city.title
                  : '-',
              address: temp[i].mission && temp[i].mission.address ? temp[i].mission.address : '-',
              ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
              phoneNumber: phoneNumber,
              cc:
                temp[i].mission && temp[i].mission.chiefComplaintText
                  ? temp[i].mission.chiefComplaintText
                  : '-',
              hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              ambulanceStatus: temp[i].phoneCurrentState ? temp[i].phoneCurrentState : '-',
              status: temp[i].dispatchCurrentState ? temp[i].dispatchCurrentState : '-',
              user: user,
              rank: rank,
              iconColor: iconColor,
              iconClass: iconClass,
            });
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionsByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionsByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionByfollowUpFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionByFollowUp', id).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.missionPhoneModule.followUpMission;
          this.loadFollowUpDashboardDetail(temp);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionByfollowUpFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionByfollowUpFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionDataByfollowUpFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionDataByFollowUp', id).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpMission') {
            let temp = this.$store.state.missionPhoneModule.followUpMissionData;
            this.loadFollowUpMissionData(temp);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionDataByfollowUpFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionDataByfollowUpFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setDataByFollowUpFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let finishKM = null;
      let arriveToStationKM = null;
      let moveFromStationKM = null;
      if (this.moveFromStationKM != null) {
        moveFromStationKM = Number(this.moveFromStationKM);
      }
      if (this.finishKM != null) {
        finishKM = Number(this.finishKM);
      }
      if (this.arriveToStationKM != null) {
        arriveToStationKM = Number(this.arriveToStationKM);
      }

      if (!this.moveFromStationTime) {
        this.moveFromStationTime = null;
      }
      if (!this.arriveToLocationTime) {
        this.arriveToLocationTime = null;
      }
      if (!this.moveFromLocationTime) {
        this.moveFromLocationTime = null;
      }
      if (!this.arriveToHospitalTime) {
        this.arriveToHospitalTime = null;
      }
      if (!this.patientDeliveryTime) {
        this.patientDeliveryTime = null;
      }
      if (!this.finishTime) {
        this.finishTime = null;
      }
      if (!this.arriveToStationTime) {
        this.arriveToStationTime = null;
      }

      this.transformMissionLocationInfo();
      let data = {
        missionPhoneId: this.missionPhoneId,
        missionPhoneTimeAndUserForFollowUpSubmit: {
          moveFromStationTime: this.moveFromStationTime,
          arriveToLocationTime: this.arriveToLocationTime,
          moveFromLocationTime: this.moveFromLocationTime,
          arriveToHospitalTime: this.arriveToHospitalTime,
          patientDeliveryTime: this.patientDeliveryTime,
          finishTime: this.finishTime,
          arriveToStationTime: this.arriveToStationTime,
          userIds: this.userIds_Show?.map(user => user.id) ?? [],
          fourthUserId: null,
          moveFromStationKM: moveFromStationKM,
          finishKM: finishKM,
          arriveToStationKM: arriveToStationKM,
        },
        missionPhoneOperationDetail: this.missionLocationInfo,
      };

      this.$store.dispatch('setDataByFollowUp', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'اطلاعات با موفقیت ثبت شد.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-information';
          this.getMissionDataByfollowUpFunction(this.missionPhoneId);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setDataByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setDataByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    finishMissionByFollowUpFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        missionPhoneId: Number(this.missionPhoneId),
      };
      this.$store.dispatch('finishMissionByFollowUp', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.$router.push({ name: 'followUpMissions' });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.finishMissionByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.finishMissionByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    finishMissionWithOutPatientByFollowUpFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        missionPhoneId: Number(this.missionPhoneId),
        resultId: Number(this.withOutPatientResult),
        note: this.withOutPatientResultNote,
      };
      this.$store.dispatch('finishMissionWithOutPatientByFollowUp', data).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.$router.push({ name: 'followUpMissions' });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.finishMissionWithOutPatientByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.finishMissionWithOutPatientByFollowUpFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionPhoneOtherOrganizationFunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionPhoneOtherOrganization', missionId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let data = this.$store.state.missionPhoneModule.otherOrganization;
          this.readyOtherOrganization(data);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneOtherOrganizationFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneOtherOrganizationFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionPhoneAdmissionHistoryFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionPhoneAdmissionHistory', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let data = this.$store.state.missionPhoneModule.admissionHistory;
          this.readyAdmissionData(data);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneAdmissionHistoryFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneAdmissionHistoryFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionAttachListFunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionAttach800User', missionId).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let data = this.$store.state.missionModule.missionAttachList;
          this.readyMissionAttachListData(data);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionAttachListFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionAttachListFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionPhoneReportDetailFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionPhoneReportDetail', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let data = this.$store.state.missionPhoneModule.missionReportDetail;
          this.loadMissionReportDetail(data);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneReportDetailFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneReportDetailFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionPhoneReportUsersFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getMissionPhoneReportUsers', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.missionPhoneModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            let data = this.$store.state.missionPhoneModule.missionReportUsers;
            this.loadMissionReportUsers(data);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionPhoneModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getMissionPhoneReportUsersFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionPhoneModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getMissionPhoneReportUsersFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getMissionPhoneLocationsFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionPhoneLocations', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let data = this.$store.state.missionPhoneModule.missionPhoneLocation;
          this.loadPath(data);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneLocationsFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneLocationsFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionPhoneLocationsWithStateFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionPhoneLocationsWithState', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          const data = this.$store.state.missionPhoneModule.missionPhoneLocationWithState;
          this.loadPath(data);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionPhoneLocationsWithStateFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionPhoneLocationsWithStateFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    missionPhoneTemp1024Function: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('missionPhoneTemp1024', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.missionPhoneTemp1024Function(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.missionPhoneTemp1024Function(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    missionResendLastStateFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('missionResendLastState', missionPhoneId).then(() => {
        if (this.$store.state.missionPhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.showSuccessAlert(' ارسال مجدد آخرین وضعیت با موفقیت ثبت شد');
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionPhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.missionResendLastStateFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionPhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.missionResendLastStateFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      const errorText = this.$store.state.missionPhoneModule.error;
      this.showErrorAlert(errorText);
    },
  },
};
